// extracted by mini-css-extract-plugin
export var hideEditor = "_ks-2";
export var infoIcon = "_ks-3";
export var label = "_ks-1";
export var labelContainer = "_ks-0";
export var readonlyText = "_ks-4";